module.exports = __webpack_public_path__ + "static/media/children2.4a78d55f.jpg";